import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, fmtDate } from "@/lib/api";

export function PointsAuditTab() {
  const [users, setUsers] = useState([]);
  const [log, setLog] = useState([]);
  const [f, setF] = useState({ user_id: "", delta: 0, motivo: "" });
  const load = () => api.get("/admin/audit").then((r) => setLog(r.data));
  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)); load(); }, []);
  const submit = async () => {
    try {
      await api.post("/admin/score-adjustments", { ...f, delta: parseInt(f.delta, 10) });
      toast.success("Correzione registrata");
      setF({ user_id: "", delta: 0, motivo: "" });
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6">
      <div className="luma-card space-y-3">
        <h3 className="font-semibold">Correzione manuale punti</h3>
        <div className="grid gap-2 md:grid-cols-[1fr_120px_2fr_auto]">
          <select className="luma-select" value={f.user_id} onChange={(e) => setF({ ...f, user_id: e.target.value })} data-testid="adjust-user-select">
            <option value="">Utente…</option>
            {users.map((u) => <option key={u.user_id} value={u.user_id}>{u.nome}</option>)}
          </select>
          <Input type="number" value={f.delta} onChange={(e) => setF({ ...f, delta: e.target.value })} data-testid="adjust-delta-input" />
          <Input placeholder="Motivo (obbligatorio)" value={f.motivo} onChange={(e) => setF({ ...f, motivo: e.target.value })} data-testid="adjust-reason-input" />
          <Button onClick={submit} className="rounded-full" data-testid="adjust-submit-button">Registra</Button>
        </div>
      </div>
      <div className="space-y-2">
        <h3 className="font-semibold">Audit (ultime 300 azioni)</h3>
        <ul className="space-y-1 text-xs" data-testid="audit-log">
          {log.map((a) => (
            <li key={a.id} className="rounded-lg border border-border px-3 py-2">
              <span className="text-muted-foreground">{fmtDate(a.at)}</span> · <b>{a.azione}</b> · {a.entita} {a.entita_id} · <span className="text-muted-foreground">{a.actor}</span>
              {Object.keys(a.dettagli || {}).length > 0 && <span className="block break-all text-muted-foreground">{JSON.stringify(a.dettagli)}</span>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
